import { Search, X } from 'lucide-react';
import type { FilterState } from '@/types';

interface FilterBarProps {
  filters: FilterState;
  onFiltersChange: (filters: FilterState | ((prev: FilterState) => FilterState)) => void;
  placeholder?: string;
}

/**
 * FilterBar — search + filter controls for task lists.
 */
export function FilterBar({
  filters,
  onFiltersChange,
  placeholder = 'Search tasks...',
}: FilterBarProps) {
  return (
    <div className="flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 dark:border-gray-700 dark:bg-gray-900">
      <Search className="h-4 w-4 text-gray-400 dark:text-gray-400" />
      <input
        type="text"
        value={filters.search}
        onChange={(e) =>
          onFiltersChange((prev: FilterState) => ({ ...prev, search: e.target.value }))
        }
        placeholder={placeholder}
        className="flex-1 border-none bg-transparent text-sm text-gray-900 outline-none placeholder:text-gray-400 dark:text-white dark:placeholder:text-gray-500"
      />
      {filters.search && (
        <button
          onClick={() => onFiltersChange((prev: FilterState) => ({ ...prev, search: '' }))}
          className="text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-200"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export default FilterBar;
